import { render, staticRenderFns } from "./WeightHistoryChart.vue?vue&type=template&id=6fecc3d6&scoped=true&"
import script from "./WeightHistoryChart.vue?vue&type=script&lang=js&"
export * from "./WeightHistoryChart.vue?vue&type=script&lang=js&"
import style0 from "./WeightHistoryChart.vue?vue&type=style&index=0&id=6fecc3d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fecc3d6",
  null
  
)

export default component.exports